export default function initializeSdk(options) {
	// Create a queue, but don't obliterate an existing one!
	const birdeatsbug = (window.birdeatsbug = window.birdeatsbug || [])
	// If the real SDK is already on the page, return.
	if (birdeatsbug.initialize) return
	// If the snippet was invoked already, show an error.
	if (birdeatsbug.invoked) {
		// eslint-disable-next-line no-console
		console.error('birdeatsbug snippet included twice.')
		return
	}
	// Invoked flag, to make sure the snippet is never invoked twice.
	birdeatsbug.invoked = true
	// A list of the methods in the SDK to stub.
	birdeatsbug.methods = [
		'setOptions',
		'trigger',
		'resumeSession',
		'takeScreenshot',
		'startRecording',
		'stopRecording',
		'stopSession',
		'uploadSession',
		'deleteSession',
	]
	// Define a factory to create stubs. These are placeholders
	// for methods in the SDK so that you never have to wait
	// for it to load to record method calls. The `method` is
	// stored as the first argument, so we can replay the data.
	birdeatsbug.factory = function (method) {
		return function () {
			var args = Array.prototype.slice.call(arguments)
			args.unshift(method)
			birdeatsbug.push(args)
			return birdeatsbug
		}
	}
	// For each of our methods, generate a queueing stub.
	for (var i = 0; i < birdeatsbug.methods.length; i++) {
		var key = birdeatsbug.methods[i]
		birdeatsbug[key] = birdeatsbug.factory(key)
	}
	// Define a method to load the SDK
	// and that will be sure to only ever load it once.
	birdeatsbug.load = function () {
		// Create an async script element.
		var script = document.createElement('script')
		script.type = 'module'
		script.async = true
		script.src = import.meta.env.VUE_APP_SDK_URL + '/core.js'
		// Insert the script next to the first script element.
		const mountJsBefore = document.getElementsByTagName('script')[0] || document.body.firstChild
		mountJsBefore.parentNode.insertBefore(script, mountJsBefore)

		// Create an async style element
		const style = document.createElement('link')
		style.rel = 'stylesheet'
		style.type = 'text/css'
		style.href = import.meta.env.VUE_APP_SDK_URL + '/style.css'
		// Insert the styles before the 1st style
		const mountCssBefore = document.querySelector('link[rel="stylesheet"]') || mountJsBefore
		mountCssBefore.parentNode.insertBefore(style, mountCssBefore)
	}
	// Load SDK
	birdeatsbug.load()
	// Pass options
	if (!options && sessionStorage?.sdkOptions) options = JSON.parse(sessionStorage.sdkOptions)
	window.birdeatsbug.setOptions(options)
}

export const defaultPublicAppId = 'b911773e-9ffe-4dd1-9e29-c66d1a21ea1f' // this ID is setup on all environments

export const sharedSdkUiOptions = {
	defaultButton: false,
	watermark: false,
	previewScreen: {
		title: false,
		description: 'required',
	},
	text: {
		previewScreen: {
			title: 'Contact us',
			descriptionInputPlaceholder: "Let us know what's on your mind",
		},
	},
}

export function resumeSdkRecording() {
	const session = sessionStorage?.birdeatsbugSession && JSON.parse(sessionStorage.birdeatsbugSession)
	if (!session) return
	let options = {ui: sharedSdkUiOptions, publicAppId: defaultPublicAppId}
	if (sessionStorage?.sdkOptions) options = JSON.parse(sessionStorage.sdkOptions)
	initializeSdk(options)
}

// Show or hide email input from SDK session submit form depending on whether user email is known
export function setIsEmailRequiredForBugReports(email) {
	window.birdeatsbug?.setOptions({
		ui: {previewScreen: {email: email ? false : 'required'}},
		user: {email},
	})
}
